import { useState } from "react";
import { toast } from "sonner";
import "./Modal.css";
import { uploadImage } from "../../lib/actions";

export const UpdateUserModal = ({ user, onClose, onSave }) => {
  console.log(user);
  const [name, setName] = useState(user.name ?? "");
  const [username, setUserName] = useState(user.username ?? "");
  const [email, setEmail] = useState(user.email ?? "");
  const [balance, setBalance] = useState(user.balance ?? 0);
  const [reservedEth, setReservedEth] = useState(user.reservedEth ?? 0);
  const [wallet_address, setWalletAddress] = useState(user.wallet_address ?? "");
  const [img, setImg] = useState(user.avatar ?? "");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fileInput = document.getElementById("fileInput");
    const file = fileInput.files[0];
    let avatarUrl = img;
    if (file) {
      const image = await uploadImage(file);
      avatarUrl = image.previewUrl;
      setImg(image.previewUrl)
    }
    console.log({ ...user, name, email, username, avatar: avatarUrl, balance, wallet_address, reservedEth })
    onSave({ ...user, name, email, username, avatar: avatarUrl, balance, wallet_address, reservedEth });
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h3>Update User</h3>
        <form onSubmit={handleSubmit} className="form">
          <label className="label">
            Name:
            <input value={name} onChange={(e) => setName(e.target.value)} />
          </label>
          <label className="label">
            Username:
            <input value={username} onChange={(e) => setUserName(e.target.value.trim())} />
          </label>
          <label className="label">
            Email:
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled
            />
          </label>
          <label className="label">
            Balance:
            <input
              value={balance}
              onChange={(e) => setBalance(e.target.value)}
            />
          </label>
          <label className="label">
            Wallet Address:
            <input
              value={wallet_address}
              placeholder="Add your wallet address"
              onChange={(e) => setWalletAddress(e.target.value)}
            />
          </label>
          <label className="label">
            Reserved ETH:
            <input
              value={reservedEth}
              onChange={(e) => setReservedEth(e.target.value)}
            />
          </label>
          <label className="label">
            Avatar:
            <input type="file" id="fileInput" accept="image/*"/>
          </label>
          <button type="submit" className="btn">
            Save
          </button>
          <button type="button" className="btn" onClick={onClose}>
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export const UpdateProfileModal = ({ user, onClose, onSave }) => {
  console.log(user);
  const [name, setName] = useState(user.name ?? "");
  const [username, setUsername] = useState(user.username ?? "");
  const [email, setEmail] = useState(user.email ?? "");
  // const [balance, setBalance] = useState(user.balance ?? 0);
  // const [reservedEth, setReservedEth] = useState(user.reservedEth ?? 0);
  const [wallet_address, setWalletAddress] = useState(user.wallet_address ?? "");
  const [img, setImg] = useState(user.avatar ?? "");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fileInput = document.getElementById("fileInput");
    const file = fileInput.files[0];
    let avatarUrl = img;
    if (file) {
      const image = await uploadImage(file);
      avatarUrl = image.previewUrl;
      setImg(image.previewUrl)
    }
    console.log({ ...user, name, email, username, avatar: avatarUrl, wallet_address })

    onSave({ ...user, name, email, username, avatar: avatarUrl, wallet_address });
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h3>Update User</h3>
        <form onSubmit={handleSubmit} className="form">
          <label className="label">
            Name:
            <input value={name} onChange={(e) => setName(e.target.value)} />
          </label>
          <label className="label">
            Username:
            <input value={username} onChange={(e) => setUsername(e.target.value)} />
          </label>
          <label className="label">
            Email:
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled
            />
          </label>
          {/* <label className="label">
            Balance:
            <input
              value={balance}
              onChange={(e) => setBalance(e.target.value)}
            />
          </label> */}
          <label className="label">
            Wallet Address:
            <input
              value={wallet_address}
              placeholder="Add your wallet address"
              onChange={(e) => setWalletAddress(e.target.value)}
            />
          </label>
          {/* <label className="label">
            Reserved ETH:
            <input
              value={reservedEth}
              onChange={(e) => setReservedEth(e.target.value)}
            />
          </label> */}
          <label className="label">
            Avatar:
            <input type="file" id="fileInput" accept="image/*"/>
          </label>
          <button type="submit" className="btn">
            Save
          </button>
          <button type="button" className="btn" onClick={onClose}>
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export const DeleteConfirmationModal = ({ user, onClose, onConfirm }) => {
  const [input, setInput] = useState("");

  const handleConfirm = () => {
    if (input.trim().toLowerCase() === "delete") {
      onConfirm(user);
    } else {
      toast.error("You must type 'delete' to confirm.");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "8px",
          width: "400px",
          maxWidth: "90%",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          textAlign: "center",
        }}
      >
        <h3 style={{ marginBottom: "15px" }}>Delete User</h3>
        <p style={{ marginBottom: "15px" }}>
          Type <strong>delete</strong> to confirm deleting {user.name}
        </p>
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          style={{
            width: "80%",
            padding: "10px",
            marginBottom: "15px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            fontSize: "16px",
          }}
        />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            onClick={handleConfirm}
            style={{
              padding: "10px 20px",
              backgroundColor: "#e53e3e",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Confirm
          </button>
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px",
              backgroundColor: "#edf2f7",
              color: "#333",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export const BuyArtModal = ({ art, onClose, onBuy }) => {
  return (
    <div className="modal">
      <div className="modal-content">
        <h3>Buy {art.name}</h3>
        <p>Price: {art.price} ETH</p>
        <p>Are you sure you want to buy this art?</p>
        <button className="btn" onClick={() => onBuy(art)}>
          Confirm Purchase
        </button>
        <button className="btn" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  )
};

export const UpdateClubModal = ({ club, onClose, onSave }) => {
  console.log(club);
  
  const [name, setName] = useState(club.name ?? "");
  const [description, setDescription] = useState(club.description ?? "");
  const [img, setImg] = useState(club.img ?? "");
  const [chain, setChain] = useState(club.chain ?? "");
  const [acceptanceRate, setAcceptanceRate] = useState(club.acceptanceRate ?? 0);
  const [floorPrice, setFloorPrice] = useState(club.floorPrice ?? 0);
  const [owner, setOwner] = useState(club.Owner ?? "");
  const [totalVolume, setTotalVolume] = useState(club.totalVolume ?? 0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const fileInput = document.getElementById("fileInput");
    const file = fileInput.files[0];
    let imageUrl = img;
    
    if (file) {
      const image = await uploadImage(file);
      imageUrl = image.previewUrl;
      setImg(image.previewUrl);
    }

    const updatedClub = {
      ...club,
      name,
      description,
      img: imageUrl,
      chain,
      acceptanceRate: parseFloat(acceptanceRate) || 0,
      floorPrice,
      totalVolume,
      Owner: owner
    };

    console.log(updatedClub);
    onSave(updatedClub);
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h3>Update Club</h3>
        <form onSubmit={handleSubmit} className="form">
          <label className="label">
            Name:
            <input 
              type="text"
              value={name} 
              onChange={(e) => setName(e.target.value)}
              maxLength={100}
              required
              placeholder="Enter club name"
            />
          </label>

          <label className="label">
            Description:
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              maxLength={400}
              placeholder="Enter club description"
              rows={4}
              style={{ resize: 'vertical', minHeight: '80px' }}
            />
          </label>

          <label className="label">
            Chain:
            <input 
              type="text"
              value={chain} 
              onChange={(e) => setChain(e.target.value)}
              maxLength={100}
              placeholder="e.g., Ethereum, Polygon, BSC"
            />
          </label>

          <label className="label">
            Floor Price:
            <input 
              type="number"
              step="any"
              value={floorPrice} 
              onChange={(e) => setFloorPrice(parseFloat(e.target.value))}
              maxLength={200}
              placeholder="e.g. 1.5 ETH"
            />
          </label>

          <label className="label">
            Total Volume:
            <input 
              type="number"
              step="any"
              value={totalVolume} 
              onChange={(e) => setTotalVolume(parseFloat(e.target.value))}
              maxLength={200}
              placeholder="e.g. 1.5 ETH"
            />
          </label>

          <label className="label">
            Acceptance Rate (%):
            <input
              type="number"
              value={acceptanceRate}
              onChange={(e) => setAcceptanceRate(e.target.value)}
              min={0}
              max={100}
              step="0.01"
              placeholder="Reserve percentage (0-100)"
            />
          </label>

          <label className="label">
            Owner:
            <input 
              type="text"
              value={owner} 
              onChange={(e) => setOwner(e.target.value)}
              placeholder="Owner ID or address"
            />
          </label>

          <label className="label">
            Club Image:
            <input 
              type="file" 
              id="fileInput" 
              accept="image/*"
            />
            {img && (
              <div style={{ marginTop: '10px' }}>
                <img 
                  src={img} 
                  alt="Club preview" 
                  style={{ 
                    width: '100px', 
                    height: '100px', 
                    objectFit: 'cover',
                    borderRadius: '8px'
                  }} 
                />
              </div>
            )}
          </label>

          <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
            <button type="submit" className="btn">
              Save Changes
            </button>
            <button type="button" className="btn" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};